import { render } from "./Mou.vue?vue&type=template&id=64b8d5da"
import script from "./Mou.vue?vue&type=script&lang=js"
export * from "./Mou.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__